

































































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import ConversationData from '@/ts/ConversationData';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

import { Keyboard } from '@capacitor/keyboard';

@Component({
    computed: {
        ...mapGetters({
            convertTicketAllTypes: 'Messages/getConvertTicketAllTypes',
            convertTicketAllCategories: 'Messages/getConvertTicketAllCategories',
        }),
    },
})
export default class ConvertTicket extends Mixins(InputFieldMethods, DeviceMethods) {
    public ticketTitle: string = '';
    public ticketMessage: string = '';
    public ticketType: any = '';
    public ticketCategory: any = '';
    public ticketReceiver: any = '';

    constructor() {
        super();
        this.initializeKeyboardListener();
    }

    public initializeKeyboardListener(): void {
        this.device().then((deviceInfo) => {
            if (deviceInfo.platform !== 'web') {
                Keyboard.setAccessoryBarVisible({ isVisible: true });
            }
        });
    }

    get activeConversation(): ConversationData {
        return this.$store.getters['Messages/activeConversation'];
    }

    get errorCollection() {
        return this.errors.any();
    }

    public tenanatReceivers() {
        const receivers: any = [];
        this.activeConversation.participants.forEach((pt: any) => {
            const participant =  this.$store.getters['User/getCacheUser'](pt);
            if (participant && participant.isTenant) {
                receivers.push({id: participant.id, name: `${participant.firstName} ${participant.familyName}`});
            }
        });
        return receivers;
    }

    public fetchTicketCategories() {
        if (this.ticketType !== '') {
            this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_CATEGORIES, {typeId: this.ticketType, propertyId: this.activeConversation.propertyId});
        } else {
            this.$store.commit(Mutations.SET_CONVERT_TICKET_ALL_CATEGORIES, []);
        }
        this.$store.commit(Mutations.SET_CONVERT_TICKET_ALL_ASSIGNEE, []);
        this.ticketCategory = '';
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffBackButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, null);
        this.$store.commit(Mutations.SET_STAFF_CHAT_BACK_LINK, false);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('header.convert-to-ticket', 'Convert to ticket'));
    }

    public convertTicket() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const formData: any = new FormData();
                formData.append('ticketTitle', this.ticketTitle);
                formData.append('ticketMessage', this.ticketMessage);
                formData.append('ticketCategory', this.ticketCategory);
                formData.append('ticketType', this.ticketType);
                formData.append('ticketReceiver', this.ticketReceiver);
                formData.append('ticketPriority', '1');
                formData.append('ticketStatus', 'new');
                formData.append('ticketAssignee', '');
                formData.append('ticketWatchers', []);

                this.$store.dispatch(Actions.CONVERT_CONVERSATION_TICKET, {requestData: formData, conversationId: this.activeConversation.id, vue: this, type: 'janitor'});
            }
        });
    }

    public cancel() {
        this.$router.go(-1);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_CONVERT_TICKET_ALL_TYPES);
        if (this.activeConversation.title !== null && this.activeConversation.title.trim() !== '') {
            this.ticketTitle = this.activeConversation.title;
        }
    }
}
